import React from 'react';
import { Box, Paper, FormControl, Select, MenuItem, InputAdornment, OutlinedInput } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuIcon from '@material-ui/icons/Menu';
import { FilterMultiSelect } from 'dsilo-ui-components';
import { Loader } from '../../../components/loader';

export function FilterBar({
	classes,
	theme,
	dateRange,
	onDateRangeChange,
	userFilter,
	onUserFilterAnchor,
	userFilterAnchorEl,
	onUserFilterClose,
	onUserFilterSave,
	members,
	membersLoading,
}) {
	return (
		<Paper elevation={0} className={classes.filterBarWrap}>
			<Box className={classes.filterBar}>
				<MenuIcon style={{ color: theme.palette.text.secondary, marginRight: 4 }} />
				<span className={classes.filterLabel}>Filter:</span>
				<FormControl variant="outlined" size="small" className={classes.filterControl}>
					<OutlinedInput
						readOnly
						value={userFilter.length === 0 ? 'All Users' : `${userFilter.length} user(s) selected`}
						onClick={(e) => onUserFilterAnchor(e.currentTarget)}
						style={{ cursor: 'pointer' }}
						endAdornment={
							<InputAdornment position="end">
								<ArrowDropDownIcon />
							</InputAdornment>
						}
					/>
				</FormControl>
				{userFilterAnchorEl && (
					<FilterMultiSelect
						allValues={members.map((m) => ({ label: m.name, value: m.id }))}
						anchorEl={userFilterAnchorEl}
						id="user-activity-user-filter-popper"
						selectedValues={members.filter((m) => userFilter.includes(m.id)).map((m) => ({ label: m.name, value: m.id }))}
						onClose={onUserFilterClose}
						isOpen={!!userFilterAnchorEl}
						onSave={(selected) => {
							onUserFilterSave(selected.map((item) => item.value));
							onUserFilterClose();
						}}
						showLoader={membersLoading}
						filterData={members.map((m) => ({ label: m.name, value: m.id }))}
						loader={<Loader />}
					/>
				)}
				<span className={classes.filterLabel}>Date:</span>
				<FormControl variant="outlined" size="small" className={classes.filterControl}>
					<Select
						value={dateRange}
						onChange={(e) => onDateRangeChange(e.target.value)}
						displayEmpty
						MenuProps={{
							anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
							transformOrigin: { vertical: 'top', horizontal: 'left' },
							getContentAnchorEl: null,
						}}
					>
						<MenuItem value="7">Last 7 Days</MenuItem>
						<MenuItem value="10">Last 10 Days</MenuItem>
						<MenuItem value="15">Last 15 Days</MenuItem>
						<MenuItem value="30">Last 30 Days</MenuItem>
					</Select>
				</FormControl>
			</Box>
		</Paper>
	);
}
